<template>
  <v-form ref="itemsSearchFilterForm">
    <base-material-filter
      title="Търсене на артикули"
      :hasFilters="hasActiveFilters"
      v-on:do-filter="doFilter"
      v-on:remove-filter="clearFilters" 
    >
      <v-row @keypress.enter="doFilter" class="mx-1">
        <v-col md="4" cols="12">
          <v-text-field 
            label="Наименование"
            v-model="filters.name"
            autocomplete="off"
          />
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field 
            label="Автор"
            v-model="filters.author"
            autocomplete="off"
          />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field 
            label="Инв. №"
            v-model="filters.inventoryNumber"
            autocomplete="off"
          />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field 
            label="Сигнатура"
            v-model="filters.signature"
            autocomplete="off"
          />
        </v-col>
        <v-col cols="12">
          <v-combobox
            label="Тъсене на тагове"
            v-model="filters.tags"
            chips
            clearable
            multiple
            :delimiters="[' ', '\n']"
            append-icon=""
            @change="handleValues"
          >
              <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    small
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    color="primary"
                    @click="select"
                    @click:close="removeTag(item)"
                  >
                    {{ item }}
                  </v-chip>
              </template>
          </v-combobox>
        </v-col>
      </v-row>
    </base-material-filter>
  </v-form>
</template>

<script>

import { isEmptyObject } from "@/utils";

const filtersModel = Object.freeze({
  name: '',
  author: '',
  inventoryNumber: '',
  signature: '',
  isWritten: '',
  tags: []
})

export default {
  name: "itemsSearchFilter",
  props: {
    postOnClearData: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      properties: {
        isWritten: [
          {
            name: "Да",
            value: 1
          },
          {
            name: "Не",
            value: 0
          }
        ]
      },
      rules: {},
      filters: Object.assign({}, filtersModel),
      hasActiveFilters: false
    }
  },
  mounted(){},
  methods: {
    doFilter(){
      if(this.$refs.itemsSearchFilterForm.validate()){
        if(!isEmptyObject(this.filters)){
          this.filters.page = 1;
          this.hasActiveFilters = true;
          this.$emit("doFilter");
          delete this.filters.page;
        } else {
          if(this.hasActiveFilters === true)
            this.$emit("doFilter");
            
          this.hasActiveFilters = false;
        }
      }
    },
    clearFilters(){
      this.filters = Object.assign({}, filtersModel)

      this.hasActiveFilters = false;

      this.$emit("doFilter", this.postOnClearData);
    },
    handleValues(val){
      if(val.includes(' '))[
        val = val.split(' ')
      ]
    },
    removeTag(tag, idx){
      this.filters.tags.splice(idx, 1)
    },
  }
}
</script>